import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-orders.svg'

const OrdersBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Orders</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      No orders to display. You can create orders by adding a new order item to your
      cart or by approving a pending quote. If you’ve filtered the results you may need
      to remove some filters to see more.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default OrdersBlankState
